import C from "@babel/runtime/helpers/esm/objectSpread2";
import P from "@babel/runtime/helpers/esm/classCallCheck";
import I from "@babel/runtime/helpers/esm/createClass";
import T from "@babel/runtime/helpers/esm/assertThisInitialized";
import k from "@babel/runtime/helpers/esm/inherits";
import w from "@babel/runtime/helpers/esm/createSuper";
import s from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as E } from "@semcore/utils/lib/core/index";
import h, { assignProps as u, sstyled as d, Component as F } from "@semcore/core";
import a from "react";
import f from "@semcore/dropdown";
import { Box as v } from "@semcore/flex-box";
import D from "@semcore/icon/ChevronDown/m";
import L from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import B from "./PaletteManager.mjs";
import { localizedMessages as x } from "./translations/__intergalactic-dynamic-locales.mjs";
import M from "@semcore/utils/lib/enhances/i18nEnhance";
import { Item as j } from "./components/Item.mjs";
import { Colors as z, ColorsCustom as R } from "./components/colors.mjs";
import { InputColor as $ } from "./components/InputColor.mjs";
var A = (
  /*__reshadow_css_start__*/
  (E.insert(
    /*__inner_css_start__*/
    '.___SColorPickerPopper_15lm4_gg_{max-width:calc(var(--intergalactic-spacing-4x, 16px)*2 + 28px*6 + 4px*6);padding:var(--intergalactic-spacing-4x, 16px)}.___SItemContainer_15lm4_gg_{position:relative;display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;border:1px solid transparent;outline:0;cursor:pointer}@media (hover:hover){.___SItemContainer_15lm4_gg_:hover{border:1px solid var(--intergalactic-border-secondary, #e0e1e9)}}.___SItemContainer_15lm4_gg_::after{content:"";position:absolute;width:22px;height:22px;border-radius:50%;box-shadow:inset 0 0 1px var(--intergalactic-border-secondary, #e0e1e9);background:var(--value_15lm4)}@media (hover:hover){.___SItemContainer_15lm4_gg_:hover>.___SCloseIcon_15lm4_gg_{opacity:1}}.___SItemContainer_15lm4_gg_.__keyboardFocused_15lm4_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___SItemContainer_15lm4_gg_.__selected_15lm4_gg_{border:1px solid var(--intergalactic-border-info-active, #006dca)}.___SItemContainer_15lm4_gg_.__displayLabel_15lm4_gg_::after{background:var(--value_15lm4);opacity:.15}.___SItemContainer_15lm4_gg_:not(.__value_15lm4_gg_)::after{border:.9px solid var(--intergalactic-border-secondary, #e0e1e9)}.___SColorsContainer_15lm4_gg_,.___SColors_15lm4_gg_{display:flex;flex-wrap:wrap;align-items:center;gap:var(--intergalactic-spacing-1x, 4px)}.___SPaletteManager_15lm4_gg_{justify-content:space-between;margin-top:var(--intergalactic-spacing-3x, 12px);margin-left:calc(var(--intergalactic-spacing-1x, 4px) - 1px)}.___SInputContainer_15lm4_gg_,.___SPaletteManager_15lm4_gg_,.___SPlusButton_15lm4_gg_{display:flex;align-items:center}.___SPlusButton_15lm4_gg_{justify-content:center;width:28px;height:28px;border-radius:50%;cursor:pointer}@media (hover:hover){.___SPlusButton_15lm4_gg_:hover{background-color:var(--intergalactic-bg-secondary-neutral-hover, #e0e1e9)}}.___SDefaultTrigger_15lm4_gg_{display:inline-flex;align-items:center;outline:0;cursor:pointer;border:0;background:0 0;padding:0}.___SDefaultTrigger_15lm4_gg_.__keyboardFocused_15lm4_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___STriggerCircle_15lm4_gg_{position:relative;width:16px;height:16px;margin-right:calc(var(--intergalactic-spacing-1x, 4px) + 1px);border-radius:50%;background-color:var(--data-value_15lm4);border:1px solid transparent}.___STriggerCircle_15lm4_gg_:not([data-value]){border:1px solid var(--intergalactic-border-secondary, #e0e1e9)}.___STriggerCircleLine_15lm4_gg_{position:absolute;top:1px;left:1px}.___SCloseIcon_15lm4_gg_{position:absolute;top:0;right:0;display:flex;align-items:center;justify-content:center;width:12px;height:12px;border-radius:50%;background-color:var(--intergalactic-bg-primary-neutral, #ffffff);opacity:0;z-index:1}.___SLine_15lm4_gg_{position:absolute}.___SLabel_15lm4_gg_{z-index:1;color:var(--data-value_15lm4);font-size:calc(var(--intergalactic-fs-100, 12px) + 1px);font-weight:var(--intergalactic-bold, 700)}.___SItemColor_15lm4_gg_{width:20px;height:20px;border-radius:50%;border:1px solid var(--intergalactic-border-secondary, #e0e1e9);background:var(--data-value_15lm4)}.___SClearConfirm_15lm4_gg_.__hidden_15lm4_gg_,.___SConfirmColor_15lm4_gg_.__hidden_15lm4_gg_{display:none}',
    "15lm4_gg_"
  ), {
    __SColorPickerPopper: "___SColorPickerPopper_15lm4_gg_",
    __SItemContainer: "___SItemContainer_15lm4_gg_",
    __SCloseIcon: "___SCloseIcon_15lm4_gg_",
    _keyboardFocused: "__keyboardFocused_15lm4_gg_",
    _selected: "__selected_15lm4_gg_",
    __SColorsContainer: "___SColorsContainer_15lm4_gg_",
    __SColors: "___SColors_15lm4_gg_",
    __SPaletteManager: "___SPaletteManager_15lm4_gg_",
    __SInputContainer: "___SInputContainer_15lm4_gg_",
    __SDefaultTrigger: "___SDefaultTrigger_15lm4_gg_",
    __STriggerCircle: "___STriggerCircle_15lm4_gg_",
    "--data-value": "--data-value_15lm4",
    __STriggerCircleLine: "___STriggerCircleLine_15lm4_gg_",
    __SLine: "___SLine_15lm4_gg_",
    __SLabel: "___SLabel_15lm4_gg_",
    __SItemColor: "___SItemColor_15lm4_gg_",
    __SConfirmColor: "___SConfirmColor_15lm4_gg_",
    _hidden: "__hidden_15lm4_gg_",
    __SClearConfirm: "___SClearConfirm_15lm4_gg_",
    "--value": "--value_15lm4",
    _displayLabel: "__displayLabel_15lm4_gg_",
    _value: "__value_15lm4_gg_",
    __SPlusButton: "___SPlusButton_15lm4_gg_"
  })
), H = [null, "#2BB3FF", "#8649E1", "#C695FF", "#F67CF2", "#FFA9FA", "#FF8786", "#FF8C43", "#FDC23C", "#66C030", "#9BD85D", "#C7EE96"], c = /* @__PURE__ */ function(l) {
  k(o, l);
  var g = w(o);
  function o() {
    var r;
    P(this, o);
    for (var e = arguments.length, _ = new Array(e), t = 0; t < e; t++)
      _[t] = arguments[t];
    return r = g.call.apply(g, [this].concat(_)), s(T(r), "bindHandlerItemClick", function(n) {
      return function(i) {
        r.handlers.value(n, i), r.handlers.visible(!1, i), i.preventDefault();
      };
    }), r;
  }
  return I(o, [{
    key: "uncontrolledProps",
    value: function() {
      return {
        value: null,
        visible: !1
      };
    }
  }, {
    key: "getTriggerProps",
    value: function() {
      var e = this.asProps, _ = e.value, t = e.visible, n = e.getI18nText;
      return {
        value: _,
        popperVisible: t,
        getI18nText: n
      };
    }
  }, {
    key: "getColorsProps",
    value: function() {
      var e = this.asProps, _ = e.colors, t = e.getI18nText;
      return {
        colors: _,
        getI18nText: t
      };
    }
  }, {
    key: "getInputColorProps",
    value: function() {
      var e = this.asProps.getI18nText;
      return {
        getI18nText: e
      };
    }
  }, {
    key: "getItemProps",
    value: function(e) {
      var _ = this, t = this.asProps, n = t.value, i = t.displayLabel, b = t.getI18nText, y = n === e.value;
      return {
        displayLabel: i,
        onClick: this.bindHandlerItemClick(e.value),
        onKeyDown: function(m) {
          (m.key === "Enter" || m.key === " ") && (m.preventDefault(), _.bindHandlerItemClick(e.value)(m));
        },
        selected: y,
        getI18nText: b
      };
    }
  }, {
    key: "getPopperProps",
    value: function() {
      var e = this.asProps.getI18nText;
      return {
        getI18nText: e
      };
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps, _, t = this.asProps, n = t.styles, i = t.Children;
      return _ = d(n), /* @__PURE__ */ a.createElement(f, u({
        stretch: !1
      }, e), /* @__PURE__ */ a.createElement(i, _.cn("Children", {})));
    }
  }]), o;
}(F);
s(c, "displayName", "ColorPicker");
s(c, "style", A);
s(c, "enhance", [M(x)]);
s(c, "defaultProps", function() {
  return {
    defaultVisible: !1,
    defaultValue: null,
    colors: H,
    i18n: x,
    locale: "en",
    children: /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(p.Trigger, null), /* @__PURE__ */ a.createElement(p.Popper, null))
  };
});
function S(l) {
  var g = arguments[0], o = l.Children, r = l.getI18nText, e = l.value, _ = a.useMemo(function() {
    return e ? r("currentColor", {
      color: e
    }) : r("emptyColor");
  }, [e]);
  return /* @__PURE__ */ a.createElement(f.Trigger, u({
    tag: V,
    "aria-label": _,
    role: "combobox"
  }, g), /* @__PURE__ */ a.createElement(o, null));
}
S.enhance = [L()];
var V = /* @__PURE__ */ a.forwardRef(function(l, g) {
  var o = arguments[0], r, e = l.styles, _ = l.value, t = v, n = v, i = "svg";
  return r = d(e), /* @__PURE__ */ a.createElement(t, r.cn("SDefaultTrigger", C({}, u({
    tag: "button",
    ref: g
  }, o))), /* @__PURE__ */ a.createElement(n, r.cn("STriggerCircle", {
    "data-value": _
  }), !_ && /* @__PURE__ */ a.createElement(i, r.cn("STriggerCircleLine", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /* @__PURE__ */ a.createElement("rect", r.cn("rect", {
    width: "1",
    height: "14",
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 10 1)",
    fill: "#E0E1E9"
  })))), /* @__PURE__ */ a.createElement(D, r.cn("ChevronDownM", {
    color: "gray-800"
  })));
});
function K(l) {
  var g = arguments[0], o, r = l.styles, e = l.Children, _ = l.getI18nText, t = l.children, n = f.Popper;
  return o = d(r), /* @__PURE__ */ a.createElement(n, o.cn("SColorPickerPopper", C({}, u({
    "aria-label": _("palette")
  }, g))), t ? /* @__PURE__ */ a.createElement(e, o.cn("Children", {})) : /* @__PURE__ */ a.createElement(p.Colors, {
    getI18nText: l.getI18nText
  }));
}
var p = h(c, {
  Trigger: S,
  Popper: K,
  Item: j,
  Colors: z
}), se = h(B, {
  Item: p.Item,
  Colors: R,
  InputColor: $
});
export {
  se as PaletteManager,
  K as Popper,
  S as Trigger,
  p as default,
  H as defaultColors
};
